import { render, staticRenderFns } from "./GalaCertificate.vue?vue&type=template&id=5bbc079e&scoped=true&"
import script from "./GalaCertificate.vue?vue&type=script&lang=js&"
export * from "./GalaCertificate.vue?vue&type=script&lang=js&"
import style0 from "./GalaCertificate.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GalaCertificate.vue?vue&type=style&index=1&id=5bbc079e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc079e",
  null
  
)

export default component.exports